import {
  Counterparty,
  CurrencyCode,
  Invoice,
  InvoiceClass,
  InvoiceLine,
  InvoiceTaxTotals,
  InvoiceTotals,
} from 'pages/invoices/invoices.types';

export enum InvoiceClassType {
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  VAT = 'VAT',
  NO_VAT = 'NO_VAT',
}

export enum __InvoiceType {
  INVOICE = 'Invoice',
  CORRECTIVE_INVOICE = 'CorrectiveInvoice',
}

export type FormInputs = {
  invoiceClass: InvoiceClass | null;
  code?: string;
  correctedInvoice?: Invoice | null;
  issueDate?: string;
  exchangeRateDate?: string;
  currencyCode: CurrencyCode | null;
  counterparty: Counterparty | null;
  sellerCounterParty?: number;
  saleDate?: string;
  dueDate?: string;
  receiptDate?: string;
  clauses?: any[];
  description?: string;
  comment?: string;
  requiresCorrection: boolean;
  totals?: InvoiceTotals;
  taxTotals?: InvoiceTaxTotals[];
  invoiceLines?: InvoiceLine[];
};
